<script>
export default {
    name: "QuestionaireTab"
}
</script>
<template>
<div class="md:w-3/4 sm:w-full overflow-auto mt-1">
    <table class="table table-bordered table-hover">
        <thead class="bg-blue-500 text-sm text-white">
            <tr class="flex w-full">
                <th class="p-tiny w-1/3">ID</th>
                <th class="p-tiny w-1/3">Question</th>
                <th class="p-tiny w-1/3">Comment</th>
            </tr>
        </thead>
        <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" style="height:25vh;">
        </tbody>
    </table>
</div>
</template>